
import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CurrentUserStateService } from '../../../Core/Users/services/current-user-state.service';
import { userPermissionsEnum } from '../../../Core/Users/enums/user-permissions.enum';

@Injectable()
export class AccountManagementRouteGuard implements CanActivate {


    constructor(
        private currentUserState: CurrentUserStateService,
        private router: Router
    ) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.currentUserState.getPermissions().pipe(
            filter(x => x !== null),
            map(permissions => {
                if (permissions.find(x => x === userPermissionsEnum.accountsReadOnlyManager || x === userPermissionsEnum.accountManager )) {
                    return true;
                } else {
                    // Push them back to the dashboard specifically
                    this.router.navigate(['Dashboard']);
                    return false;
                }
            })
        );
    }
}
